import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FragmentsModule } from 'src/app/fragments/fragments.module';
import { AdministrationComponent } from './administration.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserCreationComponent } from './user-creation/user-creation.component';
import { RoleManagementComponent } from './role-management/role-management.component';
import { OfficeManagementComponent } from './office-management/office-management.component';
import { CreateRoleComponent } from './create-role/create-role.component';
import { OfficeCreationComponent } from './office-creation/office-creation.component';
import { AuthGuard } from 'src/app/services/auth/auth.guard';
import { AdminGuard } from 'src/app/services/auth/admin.guard';
import { ModaleOpsCabinetDeploymentComponent } from './modale-ops-cabinet-deployment/modale-ops-cabinet-deployment.component';
import { FeatureFlippingComponent } from './feature-flipping/feature-flipping.component';
import { MatTableModule } from '@angular/material/table';
import { NgSelectModule } from '@ng-select/ng-select';
import { OfficeJfseComponent } from './office-JFSE/office-jfse.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    AdministrationComponent,
    AdminHomeComponent,
    UserManagementComponent,
    UserCreationComponent,
    RoleManagementComponent,
    OfficeManagementComponent,
    OfficeCreationComponent,
    CreateRoleComponent,
    ModaleOpsCabinetDeploymentComponent,
    FeatureFlippingComponent,
    OfficeJfseComponent,
  ],
  imports: [
    CommonModule,
    FragmentsModule,
    RouterModule.forChild([
      {
        path: '',
        component: AdministrationComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
          {
            path: '',
            component: AdminHomeComponent
          },
          {
            path: 'user-management',
            component: UserManagementComponent
          },
          {
            path: 'user-creation',
            component: UserCreationComponent
          },
          {
            path: 'user-creation/:id',
            component: UserCreationComponent
          },
          {
            path: 'user-creation/:idCabinet/new',
            component: UserCreationComponent
          },
          {
            path: 'user-creation/:idCabinet/:id',
            component: UserCreationComponent
          },
          {
            path: 'role-management',
            component: RoleManagementComponent,
          },
          {
            path: 'office-management',
            component: OfficeManagementComponent
          },
          {
            path: 'create-role',
            component: CreateRoleComponent,
          },
          {
            path: 'create-role/:id',
            component: CreateRoleComponent,
          },
          {
            path: 'office-creation/:id',
            component: OfficeCreationComponent
          },
          {
            path: 'feature-flipping',
            component: FeatureFlippingComponent
          },
          {
            path: 'office-jfse',
            component: OfficeJfseComponent
          },
        ]
      },
    ]),
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    NgSelectModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
  ]
})
export class AdministrationModule { }
